import { GET_REQUIREMENTS, GET_SPARSE_REQUIREMENTS } from '../actions/types';
import { storeRequirements, storeSparseRequirements } from './reducers';

const initialState = {
  requirements: [],
  sparseRequirements: []
};

export default (state = initialState, action) => {
  switch(action.type) {
    case GET_REQUIREMENTS:
      return storeRequirements(state, action);
    case GET_SPARSE_REQUIREMENTS:
      return storeSparseRequirements(state, action);
    default:
      return state;
  }
};
